export * from './company.service';
export * from './department.service';
export * from './position.service';
export * from './masterData.service';
export * from './employee.service';
export * from './customer.service';
export * from './auth.service';
export * from './visitorType.service';
export * from './background-pattern-visitor.service';
export * from './uploadFiles.service';
export * from './card-type.service';
export * from './card-visitor.service';
export * from './logo.service';
export * from './template-visitor-card.service';
export * from './report.service';
export * from './contact-information-vip.service';
export * from './contact-information.service';
export * from './common.service';
export * from './important-person.service';
export * from './company-contract.service';
export * from './card-register.service';
export * from './gate.service';
export * from './service-fee-type.service';
export * from './event-project.service';
export * from './frame.service';
export * from './screen-saver.service';
export * from './pb-snap-image.service';
export * from './face-swap.service';
